import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "left-parenthesis",
  "use": "left-parenthesis-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left-parenthesis\"><path d=\"M48.9998472,304 L45.0062109,304 C36.7166872,304 30,310.715729 30,319 C30,327.286093 36.7185094,334 45.0062109,334 L49,334 C43.6463071,331.137491 40.0041406,325.494894 40.0041406,319 C40.0041406,312.506227 43.6456639,306.862855 48.9998472,304 Z\" transform=\"translate(-30 -304)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/left-parenthesis.svg
// module id = 730
// module chunks = 0